import { generateId } from '@shared/helpers';

export const generateChecklistClientId = () => String(generateId());
